import PageHeader from 'components/common/general/layouts/PageHeader';
import React from 'react';

const UploadSyncFilesHeader = (): JSX.Element => {
  return <PageHeader title="Upload Sync Files" subtitle="Upload and Manage sync files" spacing="WITH_ACTION_BELOW" />;
};

export default UploadSyncFilesHeader;
